export var UPPER_LOWER_CIRCUIT = "UPPER_LOWER_CIRCUIT";
export var UPPER_LOWER_CIRCUIT_STREAM = "UPPER_LOWER_CIRCUIT_STREAM";
